import styled from 'styled-components';

interface ISlidesContainerStProps {
  withBackground?: boolean;
}

export const SlidesContainerSt = styled.div<ISlidesContainerStProps>`
  position: relative;
  overflow: hidden;
  height: 100%;
  width: ${({ withBackground }) => withBackground && '100%'};
`;
